<!-- 配件销售历史 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn" style="min-height: 0; margin-top: 10px">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%; margin-bottom: 0px"
                :row-key="getRowKeys"
            >
                <el-table-column width="160px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="GoodsName" label="配件名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Origin" width="80px" label="产地" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Size" width="70px" label="规格" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip width="70px" prop="ReturnCount" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="WarehousedCount" label="已出仓数"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="AlReturnCount" label="已退数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" label="可退数量">
                    <template slot-scope="scope">
                        <div style="color: red" v-if="scope.row.WarehousedCount - scope.row.AlReturnCount == 0">
                            {{ scope.row.WarehousedCount - scope.row.AlReturnCount }}
                        </div>
                        <div v-else>{{ scope.row.WarehousedCount - scope.row.AlReturnCount }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        EntpCusOId: {
            type: String
        },
        EntpCusName: {
            type: String
        }
    },
    components: {  },
    data() {
        return {
            loading: false,
            searchData: {
                EntpCusOId: this.EntpCusOId,
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                APCate: [],
                Page: 1,
                Limit: 10
            },
            tableData: [],
            tableDataLength: 0,
        };
    },
    mounted() {
        if (this.EntpCusOId) this.searchData.EntpCusOId = this.EntpCusOId;
        else this.$.$util.warningMsg('客户信息异常，请刷新后重试');
        this.getTableData();
    },
    methods: {
        resetSearch() {
            this.searchData = {
                EntpCusOId: this.EntpCusOId,
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                APCate: [],
                Page: 1,
                Limit: 10
            };
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/GetItemsForReturnById',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        getRowKeys(row) {
            return row.EntpTempGoodsId;
        },
    }
};
</script>
<style lang="less">
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1000px;
        // height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
